import { CommunityMembershipRequestedNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { FormattedText, Typography } from "client/Components";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { setTrackingId } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { prepareHubItemTitle } from "./AnnouncementActivity";

export type CommunityMembershipRequestActivityProps = {
	data: CommunityMembershipRequestedNotificationDataViewModel;
};

export const CommunityMembershipRequestActivity = (props: CommunityMembershipRequestActivityProps): ReactElement => {
	const { data } = props;

	const {
		communityName,
		requestedBy
	} = data;

	const { computedDisplayName } = getComputedDisplayName({
		firstName: requestedBy.firstName,
		lastName: requestedBy.lastName
	});

	return (
		<span {...setTrackingId("title")}>
			<FormattedText
				text={localize("_UsernameRequestedToJoinTheCommunityCommunityName")}
				thingsToReplace={[
					{
						what: "{{Username}}",
						filler: (
							<Typography
								trackingId="user-name"
								weight="bold"
							>
								{computedDisplayName}
							</Typography>
						)
					},
					{
						what: "{{CommunityName}}",
						filler: (
							<Typography
								trackingId="community-name"
								weight="bold"
							>
								{prepareHubItemTitle(communityName)}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};
CommunityMembershipRequestActivity.displayName = "CommunityMembershipRequestActivity";
